import { useTranslation } from 'react-i18next'
import * as yup from 'yup'

export const AddRoleModalValidationSchema = () => {
  const { t } = useTranslation()

  return yup.object({
    name: yup.string().required(t('rolesPage.addRoleModal.roleRequired')),
  })
}
